<ngb-alert [hidden]="!show" [type]="'danger'" [dismissible]="false">
  You've exceeded your monthly error quota. No errors will be accepted until
  your quota resets in {{ daysRemaining }} days.
  <a class="alert-link" href="/account/plan/edit" target="_self">
    Upgrade your plan now</a
  >
  to allow more errors immediately.
</ngb-alert>
